import React, {Component} from 'react';
import $ from 'jquery';
import PageLoader from './loader';
import MainComponent from './MainComponent';
import './css/global.css';

class redisDbSizes extends MainComponent {
    constructor() {
        super();
        let thisComponent = this;

        this.state = {
            redi_data: this.noDataPreloader()
        };

        this.state = {
            'redis_load_data': setInterval(function () {
                thisComponent.loadData(global.mainDomainName + '?get_redis_db_sizes&only_json', (component, data) => {
                    if (typeof data === 'string') {
                        return;
                    }

                    // if (!isJson(data)) {
                    if (data || typeof data === 'object') {
                        thisComponent.setState({
                            redis_data: data
                        });
                    }
                });
            }, 1000)
        };
    }

    componentWillUnmount() {
        let thisComponent = this;
        let interval_key = thisComponent.get('redis_load_data');
        clearInterval(interval_key);
    }

    generateTableRows() {
        {
            // let data = JSON.parse(this.state.redis_data);
            return Object.entries(this.state.redis_data).map((value, i) => {
                return (
                    <tr key={i}>
                        <td>{value[0]}</td>
                        <td>{value[1]}</td>
                    </tr>
                );
            });
        }
    }

    noDataPreloader() {
        return (<PageLoader/>);
    }

    render() {
        if (this.state.redis_data == null) return this.noDataPreloader();
        // console.log('rendering...');

        return (
            <table className="table">
                <thead>
                <tr>
                    <th scope="col">Redis DB Name</th>
                    <th scope="col">Size</th>
                </tr>
                </thead>
                <tbody>
                {this.generateTableRows()}
                </tbody>
            </table>
        );
    }
}

export default redisDbSizes;



// WEBPACK FOOTER //
// ./src/components/redisDbSizes.js